import { render, staticRenderFns } from "./InventarioItemBemPermanenteList.vue?vue&type=template&id=35bde9ea&scoped=true"
import script from "./InventarioItemBemPermanenteList.vue?vue&type=script&lang=js"
export * from "./InventarioItemBemPermanenteList.vue?vue&type=script&lang=js"
import style0 from "./InventarioItemBemPermanenteList.vue?vue&type=style&index=0&id=35bde9ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bde9ea",
  null
  
)

export default component.exports